import React from "react";
import { ListGroup,Card, Badge, CardBody, ListGroupItem, Col, Row } from "reactstrap";

import AxisCameraDeviceCard from "./AxisCameraDeviceCard";
import HanwhaCameraDeviceCard from "./HanwhaCameraDeviceCard";
import DeviceStatusDashboard from "./DeviceStatusDashboard";
import WarningAlert from "../../WarningAlert";
import { Mail } from 'lucide-react';

const formatHeight = (height, heightUnit) => {
  if (heightUnit === "ft_in") {
    const feet = Math.floor(height / 12);
    const inches = height % 12;
    return `${feet}' ${inches}"`;
  } else {
    return `${height} ${heightUnit}`;
  }
};
const SetupRecording = ({
  selectedSubject,
  currentRecordingNumber,
  devices,
  onSettingChange,
  messages,
  cameras,
  result,
  warningComponent,
}) => {
  return (
    <div>
      {/* Warning Alert Component */}
      <div className="text-center mb-4">
        <Badge 
          color="primary" 
          className="px-4 py-2"
          style={{ 
            fontSize: '1.1rem',
            fontWeight: '500',
            borderRadius: '2rem'
          }}
        >
          Recording {currentRecordingNumber}
        </Badge>
      </div>

    
      <div className="mb-4">
      <Card className="border-0 shadow-sm mb-4">
  <CardBody>
    <Row className="align-items-center">
      <Col xs="12" sm="8">
        <div className="d-flex align-items-start">
          <div
            className="rounded-circle me-3 d-flex align-items-center justify-content-center"
            style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#eef2ff'
            }}
          >
            <span className="h4 mb-0 text-primary">
              {selectedSubject?.subjectName.charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="flex-grow-1">
            <div className="d-flex align-items-center mb-1">
              <h4 className="mb-0">{selectedSubject?.subjectName}</h4>
            </div>
            <div className="d-flex align-items-center text-muted mb-1">
              <Mail size={14} className="me-2" />
              <span>{selectedSubject?.email}</span>
            </div>
            <div className="d-flex align-items-center text-muted">
              {selectedSubject?.gender} • {new Date().getFullYear() - selectedSubject?.birthYear} years •
              {formatHeight(selectedSubject.height, selectedSubject.heightUnit)} • {selectedSubject?.weight} {selectedSubject?.weightUnit}
            </div>
          </div>
        </div>
      </Col>
      <Col xs="12" sm="4" className="text-xl-end">
        <Badge color="primary" className="me-2"   style={{ fontSize: '0.8rem' }} >
          {selectedSubject?.todayRecordings} today
        </Badge>
        <Badge color="secondary" style={{ fontSize: '0.8rem' }} >
          {selectedSubject?.allTimeRecordings} total
        </Badge>
      </Col>
    </Row>
  </CardBody>
</Card>
      </div>
      <div className="mb-4">
      {warningComponent}
      </div>
      <h6 className="mb-3">Connected Devices</h6>
      <Row>
        {devices?.map(device => (
          <Col key={device.connectionId} lg={6} md={6} xl={6} sm={12} className="mb-3">
            <DeviceStatusDashboard
              deviceName={device.deviceName}
              onSettingsChange={(setting, value) => onSettingChange(device.connectionId, setting, value)}
              enableCameraSelection={true}
              enableBleSelection={true}
              statusData={device.data?.deviceInfo}
              measurementData={messages[device.connectionId]}
              deviceState={messages[device.connectionId]?.state || ''}
              camera={device.camera}
              bleDevice={device.bleDevice === 'On'}
              deviceMode={device.mode}
              showFaceTracking={false}
              ppgDeviceOn={device.ppgDeviceOn}
            />
          </Col>
        ))}
      </Row>

      {cameras && cameras.length > 0 && (
        <h6 className="mb-3">Connected Cameras</h6>
      )}
      <ListGroup>
        <Row>
          {cameras?.map(camera => {
            if (camera.type === 'axis') {
              return (
                <Col key={camera.details?.deviceIP} md="6" className="mb-3">
                  <ListGroupItem className="border rounded p-3">
                    <AxisCameraDeviceCard camera={camera} />
                  </ListGroupItem>
                </Col>
              );
            } else if (camera.type === 'hanwha') {
              return (
                <Col key={camera.details?.deviceIP} md="6" className="mb-3">
                  <ListGroupItem className="border rounded p-3">
                    <HanwhaCameraDeviceCard camera={camera} />
                  </ListGroupItem>
                </Col>
              );
            }
            return null;
          })}
        </Row>
      </ListGroup>
    </div>
  );
};

export default SetupRecording;